import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=323c6027&scoped=true"
import script from "./GoodsList.vue?vue&type=script&lang=js"
export * from "./GoodsList.vue?vue&type=script&lang=js"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=323c6027&prod&scoped=true&lang=less"
import style1 from "./GoodsList.vue?vue&type=style&index=1&id=323c6027&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c6027",
  null
  
)

export default component.exports